import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import { withAnalyticsEvents } from '@atlaskit/analytics-next';
import fireErrorAnalytics from './fire-error-analytics';

// it's a workaround since React doesn't provide native types for this
var CatchAndReportErrors = /*#__PURE__*/function (_Component) {
  function CatchAndReportErrors() {
    _classCallCheck(this, CatchAndReportErrors);
    return _callSuper(this, CatchAndReportErrors, arguments);
  }
  _inherits(CatchAndReportErrors, _Component);
  return _createClass(CatchAndReportErrors, [{
    key: "componentDidCatch",
    value: function componentDidCatch(error, errorInfo) {
      var _this$props = this.props,
        packageName = _this$props.packageName,
        id = _this$props.id,
        attributes = _this$props.attributes,
        createAnalyticsEvent = _this$props.createAnalyticsEvent;
      var analyticsEvent = createAnalyticsEvent({
        action: 'failed'
      });
      fireErrorAnalytics({
        event: analyticsEvent,
        errorInfo: errorInfo,
        error: error,
        meta: {
          id: id,
          packageName: packageName
        },
        attributes: attributes
      });
      throw error;
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      return /*#__PURE__*/React.createElement(React.Fragment, null, children);
    }
  }]);
}(Component);
export default withAnalyticsEvents()(CatchAndReportErrors);